import usePermissionStore from "@/stores/usePermissionStore";
import { Card } from "./Card";
import styles from "./List.module.sass";

export const List = () => {
  const companyAdmins = usePermissionStore((state) => state.admins);

  return (
    <div className={styles.List}>
      {companyAdmins?.map((admin) => (
        <Card key={`Admin-${admin.user_id}`} adminInfo={admin} />
      ))}
    </div>
  );
};
